<template lang="pug">
.user-monsters.col-12.col-md-6
  .card
    .header.text-center
      div Sprite Activity
    .container
      sprite-list-item.row(
        v-for='monster in usersMonsters',
        :key='monster._id',
        :sprite='monster')
      .row.align-items-center.add-monster(v-if='usersMonsters.length === 1 && metaMaskAvailable')
        .col-3
          .circle
            img.add(src='../../assets/add.svg')
        .col-9
          .monster
            .monster-name Add a Sprite
            .desc Don’t worry! Adding another Sprite is as easy as jumping over to the Marketplace!
      .raise-sprite(v-if='allMonsters.length === 1 && this.allEvents.length === 0')
        img(src='../../assets/raise-your-sprite.svg')
        h5 Raise your sprite!
        p
          | You're the proud owner of a brand new baby sprite.
          | It's only a little seed right now, but by adding it to
          | Events, you can raise it to it's full potential.
      .row.align-items-center
        .view-all.col-12.text-center(@click='viewSprites()') View All Sprites
</template>

<style lang="scss" scoped>
  .nav {
    margin-top: .5rem;
    margin-bottom: .5rem;
  }

  .container {
    padding-left: 1.714rem;
    padding-right: 1.714rem;
  }

  .tab-pill {
    margin-right: .5em;
    padding: .2rem .5rem;
    border-radius: 20px;
    background: #fff;
    font-size: 12px;
    transition: all ease .4s;
  }

  .tab-pill.active, .tab-pill:hover {
    background: linear-gradient(to right, #9bc75a, #3ba5a8);
    cursor: pointer;
    color: #fff;
  }

  .buddy, .user-monsters {
    min-height: 300px;
    text-align: left;
  }

  .user-monsters .card {
    height: 100%;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
    margin: 0 auto;
    border: none;
  }

  .user-monsters .header {
    margin-bottom: 1.714em;
    height: 56px;
    border-radius: 16px 16px 0px 0px;
    background-color: #f7f8f6;
    padding: 1em;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    text-align: center;
    color: #6c6d69;
  }

  .user-monsters .circle {
    border-radius: 8px;
    padding: 1em;
    background-color: #f7f8f6;
    margin: 0 auto;

    img {
      width: 100%;
      display: block;
      margin: 0 auto;
    }
  }

  .add-monster {
    color: #a1a39e;

    .monster-name {
      color: #a1a39e;
    }

    .desc {
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
    }

    .circle {
      border-radius: 8px;
      border: dotted 2px #e7e9e4;
      width: 96px;
      height: 96px;
      background: #fff;

      img.add {
        width: 24px;
        height: 24px;
        margin-top: 1em;
      }
    }

    padding-top: 1em;
    padding-bottom: 1em;
    // border-top: solid 2px #f7f8f6;
    border-bottom: solid 2px #f7f8f6;
    // margin-top: 1em;
  }

  .view-all {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    color: #3ba5a8;
    padding: 1rem 2rem;
  }

  .view-all:hover {
    cursor: pointer;
  }

  .raise-sprite {
    text-align: center;

    img {
      margin-bottom: 1rem;
    }

    h5 {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #a1a39e;
    }

    p {
      max-width: 272px;
      margin: 0 auto;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #a1a39e;
    }
  }
</style>

<script>
import SpriteListItem from './SpriteListItem';
import blockchainSprites from '../../mixins/blockchainSprites';

export default {
  mixins: [blockchainSprites],
  components: {
    SpriteListItem,
  },
  data() {
    return {
      page: 'all',
    };
  },
  computed: {
    metaMaskAvailable() {
      return this.$store.state.metaMaskStatus;
    },
    allMonsters() {
      return this.$store.state.usersMonsters;
    },
    allEvents() {
      return this.$store.state.events;
    },
    usersMonsters() {
      if (this.page === 'all') return this.allMonsters.slice(0, 4);

      const activeEvents = this.allEvents.filter(event => !event.completed);

      const spritesFiltered = this.allMonsters.filter((sprite) => {
        const spriteIsActive = activeEvents.find(event => sprite._id && event.eventOptions.sprite === sprite._id);
        return this.page === 'active' ? spriteIsActive : !spriteIsActive;
      });

      return spritesFiltered.slice(0, 4);
    },
  },
  methods: {
    viewSprites() {
      this.$router.push({ name: 'MySprites' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/UserSpriteList.vue